import { ITrialLesson, ITrialStudentData } from "../../../entities/trialLesson";

export interface ITrialStudentForm {
    firstName: string;
    lastName: string;
    middleName: string;
    phone: string;
    telegram: string;
    costPerHour: string;
    parentFullName: string;
    parentPhone: string;
    parentTelegram: string;
}

interface IValidationResult {
    data?: ITrialStudentData;
    error?: string;
}

export const getTrialStudentForm = (trialLesson: ITrialLesson): ITrialStudentForm => {
    const nameParts = trialLesson.studentName.trim().split(/\s+/).filter(Boolean)
    const [lastName = '', firstName = '', ...middleNameParts] = nameParts
    const hasFullName = nameParts.length > 1

    return {
        firstName: hasFullName ? firstName : lastName,
        lastName: hasFullName ? lastName : '',
        middleName: middleNameParts.join(' '),
        phone: '',
        telegram: trialLesson.studentTg,
        costPerHour: '',
        parentFullName: '',
        parentPhone: '',
        parentTelegram: '',
    }
}

export const validateTrialStudentForm = (form: ITrialStudentForm): IValidationResult => {
    if(!form.lastName.trim()) return {error: 'Укажите фамилию студента'}
    if(!form.firstName.trim()) return {error: 'Укажите имя студента'}
    if(!form.phone.trim()) return {error: 'Укажите телефон студента'}
    if(!form.costPerHour.trim()) return {error: 'Укажите стоимость часа'}

    const costPerHour = Number(form.costPerHour.replace(',', '.'))
    if(!Number.isFinite(costPerHour) || costPerHour <= 0) return {error: 'Проверьте стоимость часа'}

    return {
        data: {
            firstName: form.firstName.trim(),
            lastName: form.lastName.trim(),
            middleName: form.middleName.trim(),
            phone: form.phone.trim(),
            telegram: form.telegram.trim(),
            costPerHour: form.costPerHour.trim().replace(',', '.'),
            parentFullName: form.parentFullName.trim(),
            parentPhone: form.parentPhone.trim(),
            parentTelegram: form.parentTelegram.trim(),
        }
    }
}
